import React from "react";

import "../../css/admin/utils/spinner.scss";

function Spinner() {
  return (
    <div className="spinner flex">
      <div className="bounce1" />
      <div className="bounce2" />
      <div className="bounce3" />
    </div>
  );
}

export default Spinner;
